import React, { Fragment } from 'react';

function Legend(props) {
  return (
    <Fragment>
      <legend className="sr-only">{props.children}</legend>
      <div aria-hidden="true" className="p-0 pb-30 text-22 leading-22 font-mont-700 font-w-400">
        {props.children}
      </div>
    </Fragment>
  );
}

export default Legend;
